module.exports = __webpack_public_path__ + "static/Jones-d1a10f9d6cf93f4750cd720bf4e0f8a4.png";